<template>
    <div class="life-style-body">
        <div class="life-style-title">
            KaitekiTV Life Style
        </div>
        <div class="life-style-msg">
            あらゆるデバイス、あらゆるシチュエーションで、<br/>
            世界中どこでも、インターネットさえあればOK！
        </div>
        <div class="life-style-carousel">
            <a-carousel :after-change="onChange" autoplay>
                <div class="carousel-inset" v-for="(n, index) in lifeStyleList" :key="index">
                    <img :src="n.image" />
                    <div class="name-area" :class="{activate: lifeIndex === index}">
                        <p>{{ n.nameEn }}</p>
                        <p>{{ n.name }}</p>
                    </div>
                </div>
            </a-carousel>
        </div>
    </div>
</template>
<script>
import lifeStyleList from '../../../images/life-style'
export default {
    data () {
        return {
            lifeStyleList,
            lifeIndex: 0
        }
    },
    methods: {
        onChange(index) {
            this.lifeIndex = index
        },
    }
}
</script>
<style scoped>
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 300px;
  background: #fff;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.life-style-body{
    background: #fff;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 30px;
}
.life-style-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.life-style-title {
    font-size: 26px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #000000;
    line-height: 13px;
    margin-bottom: 30px;
    font-weight: bold;
}
.life-style-carousel {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;
}
/**
 *重写css
 */
* >>> .ant-carousel .slick-dots li button {
    width: 9px;
    height: 9px;
    background: #DADADA;
    border-radius: 9px;
    opacity: 1;
}
* >>> .ant-carousel .slick-dots li.slick-active button {
    width: 15px;
    height: 9px;
    background: #FDB819;
}
.carousel-inset img {
    display: block;
    width: 100%;
}
.name-area {
    text-align: center;
    width: 60%;
    margin: 0 auto;
    height: 60px;
    margin-top: -35px;
    background: #fff;
    position: relative;
    z-index: 2;
}
.name-area p {
    margin: 0;
}
.name-area p:nth-child(1) {
    font-size: 24.5PX;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    line-height: 42.5PX;
}
.name-area p:nth-child(1) {
    font-size: 18px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #4C4C4C;
    line-height: 42.5px;
}
</style>